/* eslint-disable */
import { extend } from 'vee-validate'
import { required, email, max, min, alpha, alpha_num, numeric, alpha_dash, alpha_spaces } from 'vee-validate/dist/rules'
import moment from 'moment'


extend('validaPeriodoZero' , {

  validate: (value) => {
    const regexPeriodo = "^([0]?[1-9]|[1-9][0-9])+$";
    return value.match(regexPeriodo);
  },

  message: "O campo não pode conter apenas 0."

})

extend('validaPeriodoIdUm' , {

  validate: (value) => {
    let periodo = value;
    const regexPeriodo = "^([0]?[1-9][;]+|[12][0-9][;]+|3[01][;]+)+$";
    if (value.slice(-1) != ';') {
    periodo = periodo + ';'
    }
    return periodo.match(regexPeriodo);
  },

  message: "Verifique o formato inserido (Ex: 01;02;03; ... 31;) até 31 dias."

})

extend('validaDiasRepetidos' , {

  validate: (value) => {

    let arrayDiasDigitados = value.split(';').map(Number)

    let setDias = new Set()
    let temDiasRepetidos = false

    arrayDiasDigitados.forEach(dia => {
      if (setDias.has(dia)) temDiasRepetidos = true
      else setDias.add(dia)
    }
      )
    if (temDiasRepetidos)
      return false
     else return true
  },

  message: "Você inseriu dias repetidos."

})

extend('required', {
  ...required,
  message: 'Esse campo é necessário'
})

extend('email', {
  ...email,
  message: 'Email inválido'
})

extend('telRequired', {
  validate: (value) => {
    const length = value.length

    return length === 14 || length === 15 || ((value.startsWith('0800') || value.startsWith('3000')) && length >= 12)
  },
  message: 'O telefone deve ser completo'
})

extend('alpha', {
  ...alpha,
  message: 'Esse campo só pode conter letras'
})

extend('dateValidator', {
  validate: (value) => {
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) {
      return false
    }

    var parts = value.split('/')
    var day = parseInt(parts[0], 10)
    var month = parseInt(parts[1], 10)
    var year = parseInt(parts[2], 10)

    if (year < 1800 || year > 2050 || month === 0 || month > 12) {
      return false
    }

    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      monthLength[1] = 29
    }

    return day > 0 && day <= monthLength[month - 1]
  },
  message: 'Data inválida'
})

extend('dateValidatorForPass', {
  validate: (value) => {
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) {
      return false
    }

    var parts = value.split('/')
    var day = parseInt(parts[0], 10)
    var month = parseInt(parts[1], 10)
    var year = parseInt(parts[2], 10)

    let myDate = new Date(year, month - 1, day)
    let dateNow = new Date()

    if (myDate > dateNow == true) {
      return false
    }

    if (year < 1800 || year > 2050 || month === 0 || month > 12) {
      return false
    }

    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      monthLength[1] = 29
    }

    return day > 0 && day <= monthLength[month - 1]
  },
  message: 'Date invalida'
})

extend('dateValidatorForFuture', {
  validate: (value) => {
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) {
      return false
    }

    var parts = value.split('/')
    var day = parseInt(parts[0], 10)
    var month = parseInt(parts[1], 10)
    var year = parseInt(parts[2], 10)

    let dateNow = new Date()
    let myDate = new Date(year, month - 1, day, dateNow.getHours(), dateNow.getMinutes(), dateNow.getSeconds() + 1)

    if (dateNow > myDate == true) {
      return false
    }

    if (year < 1800 || year > 2050 || month === 0 || month > 12) {
      return false
    }

    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      monthLength[1] = 29
    }

    return day > 0 && day <= monthLength[month - 1]
  },
  message: 'Date invalida'
})

extend('yearValidator', {
  validate: (value) => {
    var year = parseInt(value)
    
    if (year < 1800) {
      return false
    } else {
      return true
    }
  },
  message: 'Ano inválido'
})

extend('yearValidatorForPast', {
  validate: (value) => {
    var year = parseInt(value)
    let dateNow = new Date()

    if (year < 1800 || year > dateNow.getFullYear()) {
      return false
    } else {
      return true
    }
  },
  message: 'Ano inválido'
})

extend('yearAndMonthValidator', {
  validate: (value) => {
    if (value === null || value === undefined || value === '') {
      return true
    } else {
      var parts = value.split('/')

      var day = 1
      var month = parseInt(parts[0], 10)
      var year = parseInt(parts[1], 10)

      let myDate = new Date(year, month - 1, day)
      let dateNow = new Date()

      if (myDate > dateNow == true) {
        return false
      }

      if (year < 1900 || year > 2050 || month === 0 || month > 12) {
        return false
      }

      var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

      if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
        monthLength[1] = 29
      }

      return day > 0 && day <= monthLength[month - 1]
    }
  },
  message: 'Data invalida'
})

extend('yearAndMonthValidatorOnly2MonthsPast', {
  validate: (value) => {
    if (value === null || value === undefined || value === '') {
      return false
    } else {
      var parts = value.split('/')

      var day = 1
      var month = parseInt(parts[0], 10)
      var year = parseInt(parts[1], 10)

      let myDate = `${year}-${month}-${day}`
      let momentNow = moment().format('YYYY-MM-DD')
      var dif = moment(momentNow).diff(myDate, 'month')

      if (dif == 1 || dif === 2) {
        return true
      } else {
        return false
      }
    }
  },
  message: 'Data invalida'
})

extend('yearAndMonthValidatorOnly3MonthsPast', {
  validate: (value) => {
    if (value === null || value === undefined || value === '') {
      return false
    } else {
      var parts = value.split('/')

      var day = 1
      var month = parseInt(parts[0], 10)
      var year = parseInt(parts[1], 10)

      let myDate = `${year}-${month}-${day}`
      let momentNow = moment().format('YYYY-MM-DD')
      var dif = moment(momentNow).diff(myDate, 'month')

      if (dif == 1 || dif === 2 || dif == 3) {
        return true
      } else {
        return false
      }
    }
  },
  message: 'Data invalida'
})

extend('validateDataFinal', {
  params: ['target'],
  validate(value, { target }) {
    if (value && target && target.length === 9 && value.length === 7) {
      var partsFinal = value.split('/')
      var dayFinal = 1
      var monthFinal = parseInt(partsFinal[0], 10)
      var yearFinal = parseInt(partsFinal[1], 10)

      var partsInicial = target.split('/')
      var dayInicial = 1
      var monthInicial = parseInt(partsInicial[0], 10)
      var yearInicial = parseInt(partsInicial[1], 10)

      let dataInicial = new Date(yearInicial, monthInicial - 1, dayInicial)
      let dataFinal = new Date(yearFinal, monthFinal - 1, dayFinal)

      if (dataInicial <= dataFinal) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  },
  message: 'Data inicial maior que data final'
})

extend('validatePrazoValidade', {
  params: ['target'],
  validate(value, { target }) {
    if (value && target && target.length === 11 && value.length === 10) {
      var partsFinal = value.split('/')
      var dayFinal = parseInt(partsFinal[0], 10)
      var monthFinal = parseInt(partsFinal[1], 10)
      var yearFinal = parseInt(partsFinal[2], 10)

      var partsInicial = target.split('/')
      var dayInicial = parseInt(partsInicial[0], 10)
      var monthInicial = parseInt(partsInicial[1], 10)
      var yearInicial = parseInt(partsInicial[2], 10)

      let dataInicial = new Date(yearInicial, monthInicial - 1, dayInicial)
      let dataFinal = new Date(yearFinal, monthFinal - 1, dayFinal)

      if (dataInicial <= dataFinal) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  },
  message: 'Data inicial maior que data final'
})

extend('validateDataMandato', {
  params: ['target'],
  validate(value, { target }) {
    if (value && target && target.length === 12 && value.length === 10) {
      var partsFinal = value.split('/')
      var dayFinal = parseInt(partsFinal[0], 10)
      var monthFinal = parseInt(partsFinal[1], 10)
      var yearFinal = parseInt(partsFinal[2], 10)

      var partsInicial = target.split('/')
      var dayInicial = parseInt(partsInicial[0], 10)
      var monthInicial = parseInt(partsInicial[1], 10)
      var yearInicial = parseInt(partsInicial[2], 10)

      let dataInicial = new Date(yearInicial, monthInicial - 1, dayInicial)
      let dataFinal = new Date(yearFinal, monthFinal - 1, dayFinal)

      if (dataInicial <= dataFinal) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  },
  message: 'Data inicial maior que data final'
})

extend('urlValidate', {
  validate: (value) => {
    return /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(value)
  },
  message: 'Date invalida'
})

extend('cnpjValidate', {
  message: 'CNPJ inválido',
  validate: (value) => {
    var cnpj = value.replace(/[.\-\/]/g, '').toUpperCase()

    if (cnpj === '') return false
    if (cnpj.length !== 14) return false
    if (/^(.)\1+$/.test(cnpj)) return false

    function charValue(c) {
      return c.charCodeAt(0) - 48
    }

    var d1Weights = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
    var d2Weights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

    var soma = 0
    for (var i = 0; i < 12; i++) {
      soma += charValue(cnpj.charAt(i)) * d1Weights[i]
    }
    var resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
    if (resultado !== parseInt(cnpj.charAt(12))) return false

    soma = 0
    for (var i = 0; i < 13; i++) {
      soma += charValue(cnpj.charAt(i)) * d2Weights[i]
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
    if (resultado !== parseInt(cnpj.charAt(13))) return false

    return true
  }
})

extend('alpha_num', {
  ...alpha_num,
  message: 'Não pode conter esse caracter'
})

extend('max', {
  ...max,
  message: 'Tamanho do campo excedeu o limite.'
})

extend('min', {
  ...min,
  message: 'Tamanho minimo não atendido'
})

extend('numeric', {
  ...numeric,
  message: 'Esse campo só pode conter números'
})

extend('alpha_dash', {
  ...alpha_dash,
  message: 'Não pode conter esse caracter'
})

extend('alpha_spaces', {
  ...alpha_spaces,
  message: 'Não pode conter esse caracter'
})

extend('alpha_spaces_dot', {
  validate: (value) => {
    const regexObj = /^[a-zA-Z. ]*$/

    return regexObj.test(value)
  },

  message: 'Não pode conter esse caracter'
})

extend('teste', {
  validate: () => {
    return false
  },
  message: 'Teste'
})

extend('dateMaiorHoje', {
  validate: (value) => {
    let validDate = moment(value, 'DD/MM/YYYY', true)
    let dataValidada = validDate.isValid()
    let dateBefore = validDate.isAfter()
    let year = validDate.year()

    if (!dateBefore && dataValidada) {
      return true
    } else {
      return false
    }
  },
  message: 'Dia maior que hoje'
})

extend('cpf', {
  validate: (value) => {
    value = value.replace(/[^\d]+/g, '')
    let Soma
    let Resto
    let i
    Soma = 0

    if (value == '00000000000') return false

    for (i = 1; i <= 9; i++) Soma = Soma + parseInt(value.substring(i - 1, i)) * (11 - i)
    Resto = (Soma * 10) % 11

    if (Resto == 10 || Resto == 11) Resto = 0
    if (Resto != parseInt(value.substring(9, 10))) return false

    Soma = 0
    for (i = 1; i <= 10; i++) Soma = Soma + parseInt(value.substring(i - 1, i)) * (12 - i)
    Resto = (Soma * 10) % 11

    if (Resto == 10 || Resto == 11) Resto = 0
    if (Resto != parseInt(value.substring(10, 11))) return false
    return true
  },
  message: 'CPF inválido'
})
